import { accountDeferred } from '@eureka/utils/account';
import { controlDeferred } from '@eureka/utils/control';
import { createSharedComposable } from '@vueuse/core';
import { Toast } from 'patsnap-biz';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

export const useUsageLimitModal = createSharedComposable(() => {
  const { locale } = useI18n();
  const limitModalVisible = ref(false);
  const ifLimitModalEnabled = ref(false);
  const setIfLimitModalEnabled = async () => {
    const control = await controlDeferred.promise;
    const account = await accountDeferred.promise;
    const isCompany = account._info?.company_id;
    const isEnterprise = !!isCompany;

    // if user using credits + it is NOT enterprise -> use dialog
    ifLimitModalEnabled.value = control.credit_package && !isEnterprise;
  };

  const showToast = (type: string, message: string) => {
    if (type === 'success' || type === 'warning' || type === 'info' || type === 'error') {
      Toast({
        type,
        showClose: true,
        message,
      });
    }
  };

  const handleCreditLimit = () => {
    if (ifLimitModalEnabled.value) {
      limitModalVisible.value = true;
    } else {
      let message = '';

      switch (locale.value) {
        case 'en':
          message = 'Your available usage quota is insufficient. Please contact your administrator for more access.';
          break;
        case 'cn':
          message = '你的可用额度不足，请联系管理员获取更多额度。';
          break;
        case 'tw':
          message = '你的可用額度不足，請聯絡管理員取得更多額度。';
          break;
        case 'jp':
          message = 'ご利用可能な枠が不足しています。利用枠の追加については、管理者にお問い合わせください。';
          break;
        default:
          message = 'Your available usage quota is insufficient. Please contact your administrator for more access.';
          break;
      }

      showToast('error', message);
    }
  };

  return {
    limitModalVisible,
    ifLimitModalEnabled,
    setIfLimitModalEnabled,
    handleCreditLimit,
  };
});
